import { call, put, all, takeLatest, takeEvery } from 'redux-saga/effects'
import { addCustomContent } from 'portal-modules/common/redux/modules/customContent'
import Api from 'portal-modules/referrals/api'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import createFormAction from 'portal-modules/common/redux/create-form-action'
import { addError } from 'portal-modules/common/redux/modules/errors'
import ERROR_MSGS from 'portal-modules/auth/constants/error-message'

// action types
const REQUEST_REFERRALS = 'rp/referrals/REQUEST_REFERRALS'
const RECEIVE_REFERRALS = 'rp/referrals/RECEIVE_REFERRALS'
const ADD_REFERRALS = 'rp/referrals/ADD_REFERRALS'
const REFERRAL_REQUEST_ADDED = 'rp/referrals/REFERRAL_REQUEST_ADDED'

// reducer
export default (state = {}, { type, payload }) => {
  switch (type) {
    case RECEIVE_REFERRALS:
      return {
        ...state,
        ...payload,
      }
    case REFERRAL_REQUEST_ADDED:
      return { ...state, [payload.id]: payload }
    default:
      return state
  }
}

// action creators
export const requestReferrals = () => ({ type: REQUEST_REFERRALS })
export const receiveReferrals = payload => ({
  type: RECEIVE_REFERRALS,
  payload,
})
export const addReferrals = createFormAction(ADD_REFERRALS)

// sagas
function* postAddRererrals({ payload, type }) {
  const { referral } = yield call(Api.saveReferrals, payload)

  if (referral && type === ADD_REFERRALS) {
    yield put({
      type: REFERRAL_REQUEST_ADDED,
      payload: referral,
    })
  }
}

function* fetchReferrals() {
  const {
    referrals: {
      referrals,
      settings: { referrals_custom_text },
    },
  } = yield call(Api.getReferrals)

  yield all([
    put(receiveReferrals(referrals)),
    put(addCustomContent({ referrals: referrals_custom_text })),
  ])
}

function* watchRequestedReferrals() {
  yield takeLatest(
    REQUEST_REFERRALS,
    createRequestSaga(fetchReferrals, {
      key: 'referrals',
      message: __('Finding your referrals'),
    }),
  )
}

function* watchAddReferralRequest() {
  yield takeEvery(
    ADD_REFERRALS,
    createRequestSaga(postAddRererrals, {
      key: 'referrals',
      message: __('Adding referrals.'),
      successMessage: __('Referral Request submitted.'),
      onError: function* handleAddOrUpdateContactError({ code }, { key }) {
        switch (code) {
          case 1002:
            yield put(addError({ key, message: __('Invalid Phone Number') }))
            break
          case 1206:
            yield put(addError({ key, message: __('You have exceeded the maximum number of referral requests allowed per hour. Please try again later.') }))
            break
          case 1207:
            yield put(addError({ key, message: __('A referral has already been sent to this email address/phone number within the last 24 hours. Please try again later.') }))
            break
          default:
            yield put(
              addError({
                key,
                message: ERROR_MSGS[code] || __('Something went wrong.'),
              }),
            )
            break
        }
      },
      write: true,
    }),
  )
}

export const sagas = [watchRequestedReferrals, watchAddReferralRequest]
